import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Downloadico from "../../images/Icons/download-icon.png";

function Pdfdata() {
  const [pdfData, setPdfData] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://backend.aktcorp.com/pdfs"); // ✅ NEW URL, No API Key
        const data = await response.json();
        setPdfData(data.data || data); // ✅ Adjust depending on actual API response
      } catch (error) {
        console.error("Error fetching PDF data:", error);
      }
    };

    fetchData();
  }, []);

  const categoryMapping = {
    "/division/structural-divisions": "STEEL STRUCTURE",
    "/division/Selment": "SEALENTS",
    "/division/Rtv": "AIRCRAFT MAINTENANCE SEALANT (RTV)",
    "/division/Adhesives": "ADHESIVES",
    "/division/Roofcoating": "ROOF COATINGS",
    "/division/akt-car-wash": "AKT AUTOMOTIVE",
    "/division/tire-reinforcement": "TIRE-REINFORCEMENT",
    "/division/akt-tools-division": "AKT TOOLS",
  };

  const currentCategory = categoryMapping[location.pathname];
  const filteredData = pdfData.filter((item) => item.category === currentCategory);

  return (
    <div className="p-4 bg-white rounded-lg shadow-md mt-6 mb-4">
      <h3 className="flex items-center text-lg md:text-2xl font-bold mb-4 text-black ml-10">
        <img src={Downloadico} alt="Download icon" className="w-8 h-8 mr-2" />
        PDFs Section
      </h3>

      {filteredData.length > 0 ? (
        <div className="space-y-3">
          {filteredData.map((pdf) => (
            <div
              key={pdf.id}
              className="flex items-center justify-between p-3 text-[#0c2341] border rounded-lg hover:bg-[#0c2341] hover:!text-white transition-all cursor-pointer"
              onClick={() => navigate(`/view-pdfs/${pdf.id}`, { state: { pdfUrl: pdf.s3Url } })}
            >
              <div className="flex items-center gap-2">
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" />
                </svg>
                <span className="hover:text-white font-medium text-sm">{pdf.title}</span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">No PDFs available</p>
      )}
    </div>
  );
}

export default Pdfdata;
